module.exports = __webpack_public_path__ + "img/11.b267574b.jpg";